// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"ConfirmAccount_loaderContainer__3Lus1","snackbarSuccess":"ConfirmAccount_snackbarSuccess__3v9nv","snackbarError":"ConfirmAccount_snackbarError__1rF06"};